import Rx from 'rxjs/Rx';

import App from '@/App';
import Confirmation from '@/components/Widgets/Confirmation';
import PageTitle from '@/components/Widgets/PageTitle';
import TextInput from '@/components/Widgets/TextInput/text-input';
import CustomFilters from '@/plugins/custom-filters';
import {
  ActionService,
  FileUploadService,
  HttpService,
  SleuthApiService,
  UserService
} from '@/services';
import { AuthService } from '@/services/auth.service';
import { AxiosInterceptor } from '@/services/axios.interceptor';
import { DataService } from '@/services/data.service';
import { MessageService } from '@/services/message.service';
import store from '@/store';
import Axios, { AxiosRequestConfig } from 'axios';
import Vue from 'vue';
import VueRx from 'vue-rx';

import './components';
import './plugins';
import './plugins/vuetify';
import '@babel/polyfill';

import AceEditor from './components/Widgets/Ace.vue';
import router from './router';
import { Helper } from './services/helper';

// Components
// Plugins
// VueRx can use libraries other than RxJS
// that implement the observable interface.
Vue.use(VueRx, Rx);
Vue.prototype.$messageBus = new MessageService();
Vue.component('page-title', PageTitle);
Vue.component('ace-editor', AceEditor);
Vue.component('x-text-input', TextInput);
Vue.component('confirmation', Confirmation);
Vue.use(CustomFilters);
const httpService = new HttpService(store);
const userService = new UserService(store, router, httpService);
const authService = new AuthService(store, userService, router, httpService);
const errorService = new AxiosInterceptor(
  Vue.prototype.$messageBus,
  authService
);
const dataService = new DataService(store);
Vue.prototype.$authService = authService;
Vue.prototype.$userService = userService;
Vue.prototype.$dataService = dataService;
Vue.prototype.$authService = authService;
Vue.prototype.$userService = userService;
Vue.prototype.$messageBus = new MessageService();
Vue.prototype.$http = httpService;
Vue.prototype.$upload = new FileUploadService(httpService);
Vue.prototype.$actions = new ActionService(store);
Vue.prototype.$api = new SleuthApiService(store, httpService, new Helper());

Axios.interceptors.request.use(
  function(request: AxiosRequestConfig) {
    request.withCredentials = true;
    return Promise.resolve(request);
  },
  function(error) {}
);
Axios.interceptors.response.use(
  response => {
    // Do something with response data
    return response;
  },
  error => {
    // Do something with response error
    errorService.handleError(error);
    return Promise.reject(error);
  }
);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
